import { isSkuVenue } from 'helpers/ia-logic';

export const VENUE_EXPERIENCE = Object.freeze({
  RESERVATIONS: 'RESERVATIONS',
  SKU: 'SKU',
});

export const NAV_KEY = Object.freeze({
  HOME: 'HOME',
  CLASSES: 'YIELD_MANAGEMENT',
  APPOINTMENTS: 'APPOINTMENTS',
  ORDERS: 'ORDERS',
  SKU_ORDERS: 'SKU_ORDERS',
  ITEMS: 'ITEM_MANAGEMENT',
  MENU_EDITOR: 'MENU_EDITOR',
  MENU: 'MENU',
  CALENDAR_SYNC: 'APPOINTMENTS_CALENDAR_LINK',
  PERFORMANCE: 'PERFORMANCE',
  SKU_PERFORMANCE: 'SKU_PERFORMANCE',
  OPPORTUNITIES: 'OPPORTUNITIES',
  STATS: 'NESTED_STATS',
  STANDALONE_STATS: 'STANDALONE_STATS',
  RATINGS: 'RATINGS',
  CAMPAIGNS: 'CAMPAIGNS',
  SMART_SPOT: 'SMART_SPOT',
  MANAGE: 'MANAGE',
  BUSINESS_PROFILE: 'BUSINESS_PROFILE',
  SKU_BUSINESS_PROFILE: 'SKU_BUSINESS_PROFILE',
  SCHEDULE_SETTINGS: 'MANAGE_CLASS_SCHEDULE',
  EDIT_CLASS_PAGE: 'MANAGE_CLASS_PAGES',
  SERVICES: 'MANAGE_SERVICES',
  INSTRUCTORS: 'MANAGE_INSTRUCTORS',
  PRACTITIONERS: 'MANAGE_PRACTITIONERS',
  EQUIPMENT: 'EQUIPMENT',
  DYNAMIC_PRICING: 'MANAGE_DYNAMIC_PRICING',
  INTEGRATIONS: 'INTEGRATIONS',
  SUPPORT: 'SUPPORT',
  ACCOUNT: 'ACCOUNT',
  INTERNAL: 'INTERNAL',
});

export const HOME_SECTION_KEY = Object.freeze({
  AFTER_CLASS: 'HOME_AFTER_CLASS',
  USER_INSIGHTS: 'HOME_USER_INSIGHTS',
});

const RESERVATIONS_KEYS = [
  NAV_KEY.HOME,
  NAV_KEY.CLASSES,
  NAV_KEY.APPOINTMENTS,
  NAV_KEY.ORDERS,
  NAV_KEY.ITEMS,
  NAV_KEY.CALENDAR_SYNC,
  NAV_KEY.PERFORMANCE,
  NAV_KEY.OPPORTUNITIES,
  NAV_KEY.STATS,
  NAV_KEY.STANDALONE_STATS,
  NAV_KEY.RATINGS,
  NAV_KEY.CAMPAIGNS,
  NAV_KEY.SMART_SPOT,
  NAV_KEY.MANAGE,
  NAV_KEY.BUSINESS_PROFILE,
  NAV_KEY.SCHEDULE_SETTINGS,
  NAV_KEY.EDIT_CLASS_PAGE,
  NAV_KEY.SERVICES,
  NAV_KEY.INSTRUCTORS,
  NAV_KEY.PRACTITIONERS,
  NAV_KEY.EQUIPMENT,
  NAV_KEY.DYNAMIC_PRICING,
  NAV_KEY.INTEGRATIONS,
  NAV_KEY.SUPPORT,
  NAV_KEY.ACCOUNT,
  NAV_KEY.INTERNAL,
  HOME_SECTION_KEY.AFTER_CLASS,
  HOME_SECTION_KEY.USER_INSIGHTS,
];

const SKU_KEYS = [
  NAV_KEY.HOME,
  NAV_KEY.SKU_ORDERS,
  NAV_KEY.ITEMS,
  NAV_KEY.MENU_EDITOR,
  NAV_KEY.MENU,
  NAV_KEY.SKU_PERFORMANCE,
  NAV_KEY.RATINGS,
  NAV_KEY.SKU_BUSINESS_PROFILE,
  NAV_KEY.INTEGRATIONS,
  NAV_KEY.SUPPORT,
  NAV_KEY.ACCOUNT,
  NAV_KEY.INTERNAL,
  HOME_SECTION_KEY.USER_INSIGHTS,
];

export const CAPABILITIES = Object.freeze({
  [VENUE_EXPERIENCE.RESERVATIONS]: new Set(RESERVATIONS_KEYS),
  [VENUE_EXPERIENCE.SKU]: new Set(SKU_KEYS),
});

export function venueExperience(venue) {
  if (venue && isSkuVenue(venue)) {
    return VENUE_EXPERIENCE.SKU;
  }
  return VENUE_EXPERIENCE.RESERVATIONS;
}

export function experienceAllows(venue, navKey) {
  return CAPABILITIES[venueExperience(venue)].has(navKey);
}
